<div class="card-base">
    <div class="card-content-search">
        <div class="chip-container">
            <mat-chip-list>
                <mat-chip color="accent" matTooltip="{{filt.toolTip}}" selected *ngFor="let filt of searchFilters">
                    {{ filt.valueView }}
                    <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>
        <div class="card-container mat-elevation-z1">
            <div class="clearfix">
                <div class="pull-right div-header-right">
                    <button *ngIf="!loadingAction" class="card-inline margin-top-medium" [matMenuTriggerFor]="menuItem" type="button" mat-mini-fab>
                        <mat-icon>more_vert</mat-icon>
                    </button>

                    <mat-spinner [diameter]="50" *ngIf="loadingAction"></mat-spinner>

                    <mat-menu #menuItem="matMenu">
                        <button (click)="changeControledState()" mat-menu-item>
                             <span><b>Controlado</b></span>
                        </button>
                        <button (click)="changePreFeeState()" mat-menu-item>
                            <span><b>Preliquidar</b></span>
                       </button>

                        <button (click)="changeNoFeeState()" mat-menu-item>
                            <span><b>No liquidar</b></span>
                        </button>

                        <button (click)="changeDownState()" mat-menu-item>
                            <span><b>Baja</b></span>
                        </button>
                        <mat-divider></mat-divider>
                        <button (click)="roolBackState()" mat-menu-item>
                            <span> <b>Revertir</b></span>
                        </button>
                        <mat-divider></mat-divider>
                        <button (click)="exportCsv()" mat-menu-item>
                            <span> <b>Exportar a csv</b></span>
                        </button>
                    </mat-menu>
                </div>
                <div class="pull-left div-header-left">
                    <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
                    <app-medical-fee-control-filter #filters></app-medical-fee-control-filter>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="card-content margin-botton-medium">
                <p-scrollPanel styleClass="scroll-panel">
                    <table class="search-table" mat-table [dataSource]="dataSource">

                        <ng-container matColumnDef="Select">
                            <th mat-header-cell *matHeaderCellDef>
                                <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                                </mat-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                                </mat-checkbox>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Date">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Fecha"></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div> {{ element.Date | date:'dd/MM/yyyy' }} </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="ExecutionDate">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Fecha ejecución"></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div> {{ element.ExecutionDate | date:'dd/MM/yyyy' }} </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="PatientFullName">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Paciente"></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div> {{ element.PatientFullName }} </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Protocol">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Protocolo"></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div> {{ element.Protocol }} </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="PracticeRegionName">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Práctica región"></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div> {{ element.PracticeRegionName }} </div>
                            </td>
                        </ng-container>


                        <ng-container matColumnDef="MedicalFeeAmount">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Importe"></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div> {{ element.MedicalFeeAmount }} </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="ActionName">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Acción"></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div> {{ element.ActionName }} </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="PhysicianFullName">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Médico"></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div> {{ element.PhysicianFullName }} </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="CenterName">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Centro"></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div>{{ element.CenterName }}</div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="EntityName">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Entidad"></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div>{{ element.EntityName }}</div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="ServiceName">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Servicio"></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div>{{ element.ServiceName }}</div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="StateName">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Estado"></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div>{{ element.StateName }}</div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="Amount">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Cantidad"></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div>{{ element.Amount }}</div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="Action" stickyEnd>
                            <th class="search-table-header" mat-header-cell *matHeaderCellDef></th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <mat-spinner [diameter]="20" *ngIf="loadingAction"></mat-spinner>
                                <button *ngIf="!loadingAction" mat-icon-button [matMenuTriggerFor]="menuItem">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menuItem="matMenu">
                                    <button (click)="recalculate(element)" mat-menu-item>
                                        <span><b>Revalorizar honorarios del turno</b></span>
                                    </button>
                                </mat-menu>
                            </td>
                        </ng-container>
                        <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </p-scrollPanel>
                <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
            </div>
        </div>
    </div>
</div>
